import { FLOW_STEP } from '../../stateManagement/engine/reducers/SessionReducer';

export const TopBarIndex = Object.freeze({
  PHONE: 0,
  CUSTOMER_DETAILS: 1,
  ADDRESS: 2,
});

export const TopBarIndexToFlowStep = Object.freeze({
  [TopBarIndex.PHONE]: FLOW_STEP.IDLE,
  [TopBarIndex.CUSTOMER_DETAILS]: FLOW_STEP.CUSTOMER_DETAILS,
  [TopBarIndex.ADDRESS]: FLOW_STEP.ADDRESS,
});

export const FlowStepToTopBarIndex = Object.freeze({
  [FLOW_STEP.IDLE]: TopBarIndex.PHONE,
  [FLOW_STEP.CUSTOMER_DETAILS]: TopBarIndex.CUSTOMER_DETAILS,
  [FLOW_STEP.ADDRESS]: TopBarIndex.ADDRESS,
});

export function areAllDetailsFilled(flowStep) {
  return (
    flowStep !== FLOW_STEP.INIT &&
    flowStep !== FLOW_STEP.IDLE &&
    flowStep !== FLOW_STEP.CUSTOMER_DETAILS &&
    flowStep !== FLOW_STEP.ADDRESS
  );
}

export function getStepProps(topBarIndex, flowStep) {
  if (areAllDetailsFilled(flowStep)) {
    return { topBarIndex, isSelected: false, isDone: true };
  } else if (flowStep === FLOW_STEP.INIT) {
    return { topBarIndex, isSelected: false, isDone: false };
  } else if (flowStep === FLOW_STEP.IDLE) {
    return { topBarIndex, isSelected: topBarIndex === TopBarIndex.PHONE, isDone: false };
  } else if (flowStep === FLOW_STEP.CUSTOMER_DETAILS) {
    return {
      topBarIndex,
      isSelected: topBarIndex === TopBarIndex.CUSTOMER_DETAILS,
      isDone: topBarIndex < TopBarIndex.CUSTOMER_DETAILS,
    };
  } else if (flowStep === FLOW_STEP.ADDRESS) {
    return { topBarIndex, isSelected: topBarIndex === TopBarIndex.ADDRESS, isDone: topBarIndex < TopBarIndex.ADDRESS };
  }
}

export function getStepType(topBarIndex, flowStep) {
  const { isDone, isSelected } = getStepProps(topBarIndex, flowStep);
  if (isDone) {
    return 'completed';
  } else if (isSelected) {
    return 'normal';
  } else {
    return 'disabled';
  }
}
